/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const CLOSE_FILLED_PATH =
  'M9.6 19.2C14.9019 19.2 19.2 14.9019 19.2 9.6C19.2 4.29807 14.9019 0 9.6 0C4.29807 0 0 4.29807 0 9.6C0 14.9019 4.29807 19.2 9.6 19.2ZM8.04853 6.35147C7.5799 5.88284 6.8201 5.88284 6.35147 6.35147C5.88284 6.8201 5.88284 7.5799 6.35147 8.04853L7.90294 9.6L6.35147 11.1515C5.88284 11.6201 5.88284 12.3799 6.35147 12.8485C6.8201 13.3172 7.5799 13.3172 8.04853 12.8485L9.6 11.2971L11.1515 12.8485C11.6201 13.3172 12.3799 13.3172 12.8485 12.8485C13.3172 12.3799 13.3172 11.6201 12.8485 11.1515L11.2971 9.6L12.8485 8.04853C13.3172 7.5799 13.3172 6.8201 12.8485 6.35147C12.3799 5.88284 11.6201 5.88284 11.1515 6.35147L9.6 7.90294L8.04853 6.35147Z';

const CLOSE_FILLED_VIEWBOX = 20;

/** Default fill — DS semantic error token. */
export const CLOSE_FILLED_ICON_DEFAULT_FILL = 'var(--ds-color-error, var(--pal-red-1000, #A81010))';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Close / X stroke icon (14×14). Color via `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const CloseIcon = ({
  size = 20,
  strokeWidth = 1.2,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

CloseIcon.propTypes = {
  ...iconPropTypes,
  strokeWidth: PropTypes.number,
};

/**
 * Filled dismiss-in-circle (20×20). Defaults to DS error token.
 * Pass `fill="currentColor"` to inherit from CSS `color`.
 */
const CloseFilledIcon = ({
  size = 20,
  fill = CLOSE_FILLED_ICON_DEFAULT_FILL,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${CLOSE_FILLED_VIEWBOX} ${CLOSE_FILLED_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d={CLOSE_FILLED_PATH} fill={fill} />
  </svg>
);

CloseFilledIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
};

export { CloseIcon, CloseFilledIcon };
export default CloseIcon;
